export const lightingPalette = {
  surface: {
    base: '#FBFBFB',
    raised: '#EDEFF3',
    deep: '#F6F4F1',
    card: '#FBFBFB',
    active: '#0A2538',
    disabled: '#efeff1'
  },
  content: {
    primary: '#303030',
    secondary: '#434D63',
    title: '#0A2538',
    hover: '#EA6F57',
    muted: {
      DEFAULT: '#0A2538',
      foreground: 'rgba(48,48,48,0.7)'
    }
  },
  primary: {
    foreground: '#F6F4F1',
    light: '#F6F4F1',
    DEFAULT: '#0A2538',
    dark: '#0A0D0F',
    50: '#FBFBFB',
    100: '#F6F4F1',
    200: '#F6F4F1',
    300: '#E2E4E7',
    400: '#C8CAD0',
    500: '#AFB2B9',
    600: '#969AA2',
    700: '#7D828B',
    800: '#646974',
    900: '#4B515D'
  },
  silver: {
    ultralight: '#FBFBFB',
    light: '#f3f3f6',
    DEFAULT: '#E2E4E7',
    dark: '#7D828B'
  },
  secondary: {
    light: '#E2BC88',
    DEFAULT: '#EA6F57',
    dark: '#C93D26'
  },
  accent: {
    // Semantic colors
    DEFAULT: '#EA6F57',
    hover: '#C93D26',
    info: '#0A2538',
    success: '#4BC294',
    error: '#EA6F57',
    warning: '#E2BC88'
  },
  border: {
    // Base borders
    DEFAULT: '#E2E4E7',
    subtle: '#F6F4F1',
    emphasis: '#0A2538',

    // Interactive states
    hover: '#EA6F57',
    focus: '#0A2538',
    active: '#0A0D0F',
    selected: '#EA6F57'
  },
  status: {
    none: '#E2E4E7',
    pending: '#d3c8bb',
    waiting: '#E6D4B7',
    queued: '#cdc2b4',
    ongoing: '#677593',
    sent: '#7BB3E0',
    success: '#0a2538',
    failure: '#EA6F57',
    timeout: '#C0392B',
    cancelled: '#8B0000',
    completed: '#0A2538'
  },
  glass: {
    DEFAULT: 'rgba(255, 255, 255, 0.10)',
    hover: 'rgba(255, 255, 255, 0.25)'
  }
}
